import React from "react";
import { SvgIcon } from "@mui/material";

function ExportIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19Z" />
        <path d="M8.41 9.41L11 6.83L11 16.5L13 16.5L13 6.83L15.59 9.41L17 8L12 3L7 8L8.41 9.41Z" />
      </svg>
    </SvgIcon>
  );
}

export default ExportIcon;
